<template>
    <nav class="main-nav" v-if="loading">
        <ul class="main-menu main-nav__menu" v-if="menu">
            <desktop-menu-item v-for="menuitem, index in menu" :key="menuitem.order" v-bind:item="menuitem"></desktop-menu-item>
        </ul>
    </nav>
</template>

<script>
import DesktopMenuItem from './DesktopMenuItem.vue';
import _ from 'lodash';

export default {
    name: 'DesktopNavigation',
    data() {
        return {
            loading: false,
            menu: [],
            topbar: [],
            login: null,
            contact: null
        };
    },
    methods: {
    },
    props: ['menuitems', 'actions'],
    mounted: function() {
        if(this.menuitems) {
            var menuitems = JSON.parse(this.menuitems);
            this.menu = _.sortBy(menuitems, 'order');
        }
        this.loading = true;
        const actions = JSON.parse(this.actions);
        
        this.login = actions['login'];
        this.contact = actions['contact'];
    },
    components: {
        DesktopMenuItem: DesktopMenuItem,
    },
};
</script>